/**
 * Auth Module
 */
import Nprogress from "nprogress";
import Vue from "vue";
import VueNotifications from "vue-notifications";
import { getAuthServiceInstance } from "@/helpers/authService";
import { setAmplitudeUser } from "@/telemetry/AmplitudeEvent";
import { UserLoggedOutEvent } from "@/telemetry";

const authService = getAuthServiceInstance();

const _state = {
	user: null,
	token: null,
	signupResult: null,
	loginError: null,
};

// getters
const getters = {
	user: state => {
		return state.user;
	},
	timezone: state => state?.user?.timezone || "",
	token: state => {
		return state.token;
	},
	signupResult: state => {
		return state.signupResult;
	},
	loginError: state => {
		return state.loginError;
	},
};

// actions
const actions = {
	async logoutUser( context ) {
		Nprogress.start();
		try {
			const { user, } = context.state;
			context.commit( "userLoggedOut", user );
			authService.logOut();
		} catch ( e ) {
			VueNotifications.error( {
				message: e.message || e.error || e || "Unexpected error",
			} );
			console.error( e );
		}
		Nprogress.done();
	},
};

// mutations
const mutations = {
	async userLoggedOut( state ) {
		state.user = null;
		state.token = null;
		state.signupResult = null;
		const telemetryEvent = new UserLoggedOutEvent();
		await telemetryEvent.submit();
	},
	/**
	 * @param state
	 * @param authResult - result of the authService loginEvent event
	 * @returns {Promise}
	 */
	async onSessionUpdate( state, authResult ) {
		if ( !authResult || !authResult.loggedIn ) {
			state.user = null;
			state.token = null;
			state.signupResult = null;
			setAmplitudeUser( null );
			return;
		}
		state.token = authResult.token;
		state.user = authResult.user;
		setAmplitudeUser( state.user );

		Vue.rollbar.configure( {
			payload: {
				person: {
					email: state.user.email,
					username: state.user.username,
				},
			},
		} );

		Nprogress.doneAll();
	},
	onLoginError( state, err ) {
		state.loginError = err;
	},
};

export default {
	state: _state,
	getters,
	actions,
	mutations,
	namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js